export default {
  navOpen: false,
  backgroundColor: false,
  projectNav: false
}
